import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate } from 'react-router-dom';
import * as signalR from '@microsoft/signalr';
import { dbtctStoreLogin } from '../../../Features/tctappstoreslice'
import { useDispatch } from 'react-redux';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../../../api/sso/msalconfig';
import { callMsGraph } from '../../../api/sso/graph';
import { glbChangeMode, glbGetLocalStorage, glbSetLocalStorage, fnLoadRights, CallConfirmDialog, glbEncryptData, glbDecryptData, glbLoadFavourites, glbSwitchOrgEnv, glbGetConfig, glbSetCurrentDomain, glbSetSessionStorage, glbConnectHub, mobileCheck, glbGetAppSettings, fnlChangeApplicationLanguage, glbGetLanguageJSON, glbPostMessage, showAlert, glbHasValues } from '../../../Helpers/GlobalFunctions';
import CallApi from '../../../apiConnect/CallApi';
import { GetTenantFromDomain } from '../../../Helpers/DomainProcess';
import { useSelector } from 'react-redux';
import { glbScreenLoader as setLoading } from '../../../Helpers/GlobalFunctions';
import { ReactSession } from 'react-client-session';
import { useSearchParams } from "react-router-dom";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { v1 as uuidv1 } from 'uuid';
import { widowControlProperty } from '@syncfusion/ej2-react-documenteditor';
import { ComboBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import SterCaptcha from '../../../userctrls/SterCtrls/SterCaptcha';
import { OtpInputComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AuthBaseURL, GatewayURL } from '../../../apiConnect/config';
import axios from 'axios';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import OreChangePassword from '../../../Helpers/ChangePassword';
import AllDomainInfo from './AllDomainInfo.json';
import loLanguage from '../../../oredesign/orelanguage.json';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
/*
Comment
Local - l, Global - g
dataset (json) - jsd
Function - fn 
Page Component - Pge  :  User Component : Ucom
Parameter - p : Props - prop 
string - s : numeric - n : date - d : datetime -dt : object - o : boolean - b
*/


export default function PgeLogin() {

    // const [loading, setLoadingtoberemoved] = useState(false);
    const [propsEmail, setPropsEmail] = useState('');
    const [propsPassword, setPropsPassword] = useState('');
    const [propsEmailerr, setPropsEmailerr] = useState('');
    const [propsPswderr, setPropsPswderr] = useState('');
    const [propsCompanyerr, setPropsCompanyerr] = useState('');
    const [propsProjecterr, setPropsProjecterr] = useState('');
    const [propsDomain, setPropsDomain] = useState('');
    const [propsimglogo, setpropsimglogo] = useState('');
    const [propsdomainlogo, setpropsdomainlogo] = useState('');
    const [propsisremember, setpropsisremember] = useState(false);
    const [propsdomaininfo, setpropsdomaininfo] = useState({});
    const [isNetWorkValid, setisNetWorkValid] = useState(false);
    const [isShowFailure, setisShowFailure] = useState(false);
    const [isMobileSSO, setisMobileSSO] = useState(false);
    const [isWebView, setisWebView] = useState(false);
    const [sosEmail, setSosEmail] = useState('')
    const [propsPasswordtype, setpropsPasswordtype] = useState("password");
    const [isMultipleLanguage, setisMultipleLanguage] = useState(false);
    const [isHideRememberMe, setisHideRememberMe] = useState(false);
    const loNavigate = useNavigate();
    const loDispatch = useDispatch()
    const { instance, accounts } = useMsal();
    const loLoginButton = useRef();
    const loChatLoginButton = useRef();
    // const reforgenvjson = useRef();
    // const refappjson = useRef();
    const refLoginBlock = useRef();
    // const tctappstore = useSelector(state => state.tctappstore.value);
    const refssologininfo = useRef('');
    const refhomeAccountId = useRef('');
    let [searchParams, setSearchParams] = useSearchParams();
    let refopenpagejson = useRef("");
    const refisremember = useRef(false);
    const refremembermeinfo = useRef({});
    let reflbhomeoptions = useRef("");
    let refLanguage = useRef({});
    let refSterCaptcha = useRef();
    // let locaptchainfo = useRef({ needcaptcha: false, wrongcount: 0 });
    let refUserSettting = useRef({});
    let lbneedssocompanyproject = false;
    let loProceedButton = useRef();
    let reflogin_changepassword = useRef();
    let reflogin_optverification = useRef();
    let refloginsettings = useRef([]);
    let refOreChangePassword = useRef(null);
    let refLoginInfo = useRef({ logindata: {}, loginid: "", password: "", company: "", config: "", email: "" });
    const [propsusernamedisabled, setpropsusernamedisabled] = useState(false);
    const [propspassworddisabled, setpropspassworddisabled] = useState(false);
    let refloginsettingsinfo = useRef({ logintyp: "emailid", urules: [], loginname: "Email ID", loginbuttoncaption: "Login", visible: false, fields: { "value": "code", "text": "name" }, dataSource: [], domainvisible: false });
    let lsEnvDomain = window.location.host;
    if (lsEnvDomain.includes("localhost:44466") || lsEnvDomain.includes("dev.oreapps.com") || lsEnvDomain.includes("sterqa.oreapps.com") || lsEnvDomain.includes("182.20.10.212:44466")) {
        refloginsettingsinfo.current.domainvisible = true;
    }
    let lscurrenttpdomainInfo = ReactSession.get("currenttpdomain");
    const [propsloginsettingsinfo, setpropsloginsettingsinfo] = useState(refloginsettingsinfo.current);
    let lbneedlogoutissuewhenloading = false;
    let lbzissterapp = glbGetLocalStorage("zissterapp");
    const emailInputRef = useRef(null);
    const paswordInputRef = useRef(null);
    async function fnlChangeUserSettings(pstype, pnvalue) {
        if (pstype === "company") {
            refUserSettting.current.project.value = "";
            refUserSettting.current.project.dataSource = [];
            refUserSettting.current.project.refresh();
            let companyitemdata = { orgid: "", envtype: "" };
            let lncompslno = refUserSettting.current.company.value;
            if (lncompslno > 0) {
                companyitemdata = refUserSettting.current.company.itemData;
                glbSetLocalStorage("tcd", companyitemdata.datatnt);
            }
            let loProjAccess = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 653, ver: -1, alias: "kH3gJVvBoc", lparams: { "acsocd1": companyitemdata.orgid, "acsacd1": 0, "pntype": "30", "acstcd1": companyitemdata.datatnt } }, toa: "u" });
            if (loProjAccess.status === true || loProjAccess.status === 200) {
                refUserSettting.current.project.dataSource = loProjAccess.data;
                glbSetLocalStorage("projects", loProjAccess.data);
                if (loProjAccess.data.length === 1) {
                    refUserSettting.current.project.value = loProjAccess.data[0]['code'];
                    // await fnLoadAccessData(refUserSettting.current.project.value, 'u');
                }
                else if (loProjAccess.data.length > 0 && pnvalue > 0) {
                    refUserSettting.current.project.value = pnvalue;
                }
            }
            else {
                if (loProjAccess.errmsg !== undefined && loProjAccess.errmsg !== null && loProjAccess.errmsg !== "") {
                    CallConfirmDialog("info", loProjAccess.errmsg);
                }
                // showAlert(loProjAccess.errmsg, 'error');
            }
            refUserSettting.current.project.refresh();
        }
        else if (pstype === "project") {

        }
        else {
            loLoginButton.current.classList.add("d-none");
            loProceedButton.current.classList.remove("d-none");
            let lossUserData = glbGetLocalStorage("ssUserData");
            if (typeof lossUserData !== "object") {
                loNavigate("/");
            }
            let loUserconfig = glbGetLocalStorage('ssUserConfig');
            let lorefinfo = loUserconfig.defvalues;
            refUserSettting.current.company.fields = { "value": "code", "text": "orgenvname" };
            refUserSettting.current.company.dataSource = lossUserData.org;
            let loorgenvfilter = refUserSettting.current.company.dataSource.filter((e) => { return e.orgid === lorefinfo.orgid && e.envtype.toLowerCase() === lorefinfo.envtype.toLowerCase() });
            if (loorgenvfilter.length > 0) {
                refUserSettting.current.company.value = loorgenvfilter[0].code;
                refUserSettting.current.company.refresh();
            }
            else {
                refUserSettting.current.company.value = "";
            }
            await fnlChangeUserSettings("company", lorefinfo.projid);
            setpropsusernamedisabled(true);
            setpropspassworddisabled(true);
            document.getElementById("login_microsoftlogin").classList.add("d-none");
        }
    }
    function fnlProceed() {
        if (!(refUserSettting.current.company.value > 0)) {
            setPropsCompanyerr("Please fill out Company");
            return
        }
        else {
            setPropsCompanyerr("");
        }
        if (!(refUserSettting.current.project.value > 0)) {
            setPropsProjecterr("Please fill out Project")
            return
        }
        else {
            setPropsProjecterr("");
        }
        let loUserconfig = glbGetLocalStorage('ssUserConfig');
        if (loUserconfig !== undefined && loUserconfig !== null && loUserconfig !== "") {
            loUserconfig.defvalues.orgid = refUserSettting.current.company.itemData.orgid;
            loUserconfig.defvalues.projid = refUserSettting.current.project.value;
        }
        glbSetLocalStorage("ssUserConfig", loUserconfig);
        loNavigate(lbzissterapp + '/newdesign');
    }
    function ProcessGraphResponse(poResponse) {
        poResponse.homeAccountId = refhomeAccountId.current;
        // glbSetLocalStorage("ssoinfo", poResponse);
        fnlHandleClick('', false, poResponse);
    }
    function MobileSSOLogin(usermail) { //Native SSO
        let inpJson = {}
        inpJson.homeAccountId = refhomeAccountId.current;
        inpJson.mail = usermail;
        glbSetCurrentDomain()
        fnlHandleClick('', false, inpJson, '', '', window.location.hostname);
    }
    function LoginMSSAML(loginType) {
        try {
            if (loginType === "popup") {
                instance.loginPopup(loginRequest).then(e => {
                    //    console.log(e.account);
                    // console.log("SSO Login Attempt Succeeded ")
                    instance
                        .acquireTokenSilent({
                            ...loginRequest,
                            account: e.account,
                        })
                        .then((response) => {
                            refhomeAccountId.current = response.account.homeAccountId;
                            callMsGraph(response.accessToken).then((response) => { ProcessGraphResponse(response) }).catch(function () { });
                        }).catch(function () { });
                }).catch(function (err) {
                    console.log(err)
                });;

            }
        }

        catch (err) { window.alert("Error in Authentication" + err) }
        finally { }
    }
    // React.useEffect(async() => {
    //     rendereComplete();
    //     fnlGetModelData();
    // });    
    useEffect(() => {
        let isSSOLogin = false;
        try { //Native SSO
            const navigator = window.navigator;
            const userAgent = navigator.userAgent;
            const normalizedUserAgent = userAgent.toLowerCase();
            const standalone = navigator.standalone;
            const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
            const isAndroid = /android/.test(normalizedUserAgent);
            const isSafari = /safari/.test(normalizedUserAgent);
            const isWebview = (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari);
            // const osText = isIos ? 'iOS' : isAndroid ? 'Android' : 'Other';
            const webviewText = isWebview ? 'Yes' : 'No';
            if (webviewText == 'Yes') {
                setisWebView(true)
            }
        } catch (err) {
            console.log(err)
        }
        //Native SSO     
        const query = new URLSearchParams(window.location.search);
        let ssotoken = query.get('ssotoken');
        if (ssotoken !== undefined && ssotoken !== null) {
            refLoginBlock.current.style.display = 'none';
            setLoading(true);
            isSSOLogin = true;
        }
        document.body.classList.add('p-0')
        const fnlLoadInit = async () => {
            await fnlLoad()
            if (isSSOLogin === true) { //Native SSO
                let usermail = atob(ssotoken);
                setisMobileSSO(true)
                setSosEmail(usermail)
                MobileSSOLogin(usermail);
            }
        };
        fnlLoadInit();
        if (window.location.pathname.includes("/logout")) {
            setTimeout(() => {
                try {
                    const emailinput = emailInputRef.current?.element;
                    const passinput = paswordInputRef.current?.element;
                    if (emailinput && emailinput.value && emailinput.value.length > 0) {
                        const event = new Event('input', { bubbles: true });
                        emailinput.dispatchEvent(event);
                        const val = emailinput.value;
                        emailinput.value = '';
                        emailinput.value = val;
                    }
                    if (passinput && passinput.value && passinput.value.length > 0) {
                        const event = new Event('input', { bubbles: true });
                        passinput.dispatchEvent(event);
                        const val = passinput.value;
                        passinput.value = '';
                        passinput.value = val;
                    }
                } catch (error) {
                    console.log(error)
                }
            }, 1500);
        }
        return () => {
            //it is called when the component unloading
        }
    }, []);
    useEffect(() => {
        let lsdeflang = glbGetLocalStorage("deflang");
        if (lsdeflang !== "" && lsdeflang !== undefined && lsdeflang !== null && lsdeflang !== "en") {
            fnlChangeApplicationLanguage(lsdeflang, "en");
        }
    }, [isNetWorkValid]);
    async function fnlHomeOptionSettings() {
        if (lbneedlogoutissuewhenloading) {
            glbSetLocalStorage("logoutissue", lbneedlogoutissuewhenloading);
        }
        reflbhomeoptions.current = { theme: "", defappvalue: "", startuppage: "", startupref: "", ssologin: false, globaltheme: "", aichat: false };
        let lohomeoptions = glbGetAppSettings("uo");
        if (lohomeoptions !== "") {
            if (lohomeoptions.dm !== "") {
                reflbhomeoptions.current.theme = lohomeoptions.dm;
            }
            if (lohomeoptions.dav !== "") {
                reflbhomeoptions.current.defappvalue = lohomeoptions.dav;
                if (reflbhomeoptions.current.defappvalue > 0) {
                    reflbhomeoptions.current.defappvalue = Number(reflbhomeoptions.current.defappvalue);
                }
            }
            if (lohomeoptions.hasOwnProperty("dv") === true) {
                reflbhomeoptions.current.defview = lohomeoptions.dv;
                if (typeof reflbhomeoptions.current.defview === "object") {
                    if (reflbhomeoptions.current.defview.t !== undefined && reflbhomeoptions.current.defview.t !== "") {
                        reflbhomeoptions.current.startuppage = reflbhomeoptions.current.defview.t;
                    }
                    if (reflbhomeoptions.current.defview.i > 0) {
                        reflbhomeoptions.current.startupref = reflbhomeoptions.current.defview.i;
                    }
                }
            }
        }
        lohomeoptions = glbGetAppSettings("ho");
        if (lohomeoptions !== "") {
            if (typeof lohomeoptions.athm === "string" && lohomeoptions.athm !== "") {
                reflbhomeoptions.current.globaltheme = lohomeoptions.athm;
                glbSetLocalStorage("globaltheme", lohomeoptions.athm);
            }//global theme assign number values
            else if (lohomeoptions.athm !== null && lohomeoptions.athm !== "") {
                // console.log(lohomeoptions.athm)
                reflbhomeoptions.current.globaltheme = lohomeoptions.athm;
                glbSetLocalStorage("globaltheme", lohomeoptions.athm);
            }
        }
        lohomeoptions = glbGetAppSettings("as");
        if (lohomeoptions !== "") {
            if (lohomeoptions.sso === "y") {
                reflbhomeoptions.current.ssologin = true;
            }
            if (lohomeoptions.aic === "y") {
                reflbhomeoptions.current.aichat = true;
            }
        }
        if (lscurrenttpdomainInfo === "dev.oreapps.com") {
            reflbhomeoptions.current.aichat = true;
        }
    }
    async function fnlLoad(podomaininfo) {
        if (document.getElementById("divorecontrolhome")) {
            document.getElementById("divorecontrolhome").remove();
        }
        if (document.getElementById("divtaskhistory")) {
            document.getElementById("divtaskhistory").remove();
        }
        if (window.location.pathname.includes("openpage")) {
            let linkid = "";
            for (const entry of searchParams.entries()) {
                if (entry[0] === "MID" || entry[0] === "q") {
                    linkid = entry[1];
                }
            }
            refopenpagejson.current = linkid;
            // console.log(linkid);
        }
        let lorememberme = glbGetLocalStorage("rememberme");
        let lsuniqueid = glbGetLocalStorage("uniqueid");
        if (!(lsuniqueid !== undefined && lsuniqueid !== null && lsuniqueid !== "")) {
            lsuniqueid = uuidv1();
        }
        let lscurrenttpdomain = ReactSession.get("currenttpdomain");
        if (window.location.pathname.includes("/logout")) {
            if (propsloginsettingsinfo.domainvisible === true && podomaininfo !== undefined) {
                let lodngwinfpo = podomaininfo;
                await glbGetConfig(lodngwinfpo);
                // let lscurrenttpdomain = ReactSession.get("currenttpdomain");
                // ReactSession.set(lscurrenttpdomain + '-bannerinfo', lobannerinfo);
                // await glbSetLocalStorage("bannerinfo", lobannerinfo);
                await fnlGetTenantFromDomain(lodngwinfpo);
            }
            else {
                let lscurrenthref = ReactSession.get("currenthref");
                let loconfig = glbGetLocalStorage("config");
                let lobannerinfo = glbGetLocalStorage("bannerinfo");
                let lodomaininfo = glbGetLocalStorage("domaininfo");
                let loappsett = glbGetLocalStorage("appsett");
                let lsapplang = glbGetLocalStorage("applang");
                let lsdeflang = glbGetLocalStorage("deflang");
                let lstlydesgnreqd = glbGetLocalStorage("tlydesgnreqd");
                let lsloginsett = glbGetLocalStorage("loginsett");
                let lscdata = glbGetLocalStorage("cdata");
                let lsRefreshToken = glbGetLocalStorage("refreshtoken");
                let lsAccessToken = glbGetLocalStorage("accesstoken");
                let lszissterapp = glbGetLocalStorage("zissterapp");
                let lslogopath = glbGetLocalStorage("logopath");
                let lsAudAppli = glbGetLocalStorage("audappl");
                await glbSetLocalStorage("clearsession", "");
                await glbSetSessionStorage("clearsession", "");
                ReactSession.set("currenttpdomain", lscurrenttpdomain);
                ReactSession.set("currenthref", lscurrenthref);
                await glbSetLocalStorage("config", loconfig);
                await glbSetLocalStorage("bannerinfo", lobannerinfo);
                await glbSetLocalStorage("appsett", loappsett);
                await glbSetLocalStorage("applang", lsapplang);
                await glbSetLocalStorage("deflang", lsdeflang);
                await glbSetLocalStorage("tlydesgnreqd", lstlydesgnreqd);
                await glbSetLocalStorage("loginsett", lsloginsett);
                await glbSetLocalStorage("cdata", lscdata);
                await glbSetLocalStorage("zissterapp", lszissterapp);
                await glbSetLocalStorage("logopath", lslogopath);
                await glbSetLocalStorage("audappl", lsAudAppli);
                if (lbneedlogoutissuewhenloading) {
                    glbSetLocalStorage("islogout", true);
                }
                await fnlLoadLoginInfo(lodomaininfo);
                setisNetWorkValid(true);
                fnlShowMultipleLanguage();
                setLoading(false)
                for (const entry of searchParams.entries()) {
                    if (entry[0] === "q") {
                        let lsquerystring = JSON.parse(entry[1]);
                        console.log(lsquerystring);
                        let lomsgarray = [];
                        lomsgarray.push("Current Date - " + new Date(lsquerystring.cdt).getDate() + "/" + parseInt(new Date(lsquerystring.cdt).getMonth() + 1) + "/" + new Date(lsquerystring.cdt).getFullYear() + " " + new Date(lsquerystring.cdt).toLocaleTimeString());
                        lomsgarray.push("Expiry Date - " + new Date(lsquerystring.edt).getDate() + "/" + parseInt(new Date(lsquerystring.edt).getMonth() + 1) + "/" + new Date(lsquerystring.edt).getFullYear() + " " + new Date(lsquerystring.edt).toLocaleTimeString());
                        lomsgarray.push("Message - " + lsquerystring.msg);
                        lomsgarray.push("Data - " + lsquerystring.data);
                        lomsgarray.push("Status - " + lsquerystring.status);
                        CallConfirmDialog('warning', lomsgarray);
                    }
                }
                if (lbneedlogoutissuewhenloading) {
                    try {
                        let lsGatewayURL = GatewayURL;
                        let lsAuthURL = AuthBaseURL;
                        let loconfig = glbGetLocalStorage("config");
                        if (loconfig !== undefined && loconfig !== null) {
                            if (loconfig.hasOwnProperty("gatewayurl")) {
                                lsGatewayURL = loconfig.gatewayurl;
                            }
                            if (loconfig.hasOwnProperty("authbaseurl")) {
                                lsAuthURL = loconfig.authbaseurl;
                            }
                        }
                        let loRefreshTokenHeader = { "Content-Type": "application/json", "Authorization": "Bearer " + lsAccessToken, "toa": "g", "RefreshToken": lsRefreshToken };
                        const tknresponse = await axios.post(lsGatewayURL + lsAuthURL + "Authentication/TenantLogout", "", { headers: loRefreshTokenHeader });
                    }
                    catch (err) {
                        console.log(err);
                    }
                }
            }
        }
        else {
            let lobannerinfo = glbGetLocalStorage("bannerinfo");
            await glbSetLocalStorage("clearsession", "");
            await glbSetSessionStorage("clearsession", "");
            let lodngwinfpo = {};
            for (const entry of searchParams.entries()) {
                if (entry[0] === "dn" || entry[0] === "gw") {
                    lodngwinfpo[entry[0]] = entry[1];
                }
            }
            if (propsloginsettingsinfo.domainvisible === true) {
                if (podomaininfo !== undefined) {
                    lodngwinfpo = podomaininfo;
                }
                /*else {
                    let lotemp = AllDomainInfo.filter(function (item) { return item.dn === lscurrenttpdomain });
                    if (lotemp.length > 0) {
                        setPropsDomain(lscurrenttpdomain);
                        lodngwinfpo = lotemp[0];
                    }
                }*/
            }
            await glbGetConfig(lodngwinfpo);
            // let lscurrenttpdomain = ReactSession.get("currenttpdomain");
            // ReactSession.set(lscurrenttpdomain + '-bannerinfo', lobannerinfo);
            await glbSetLocalStorage("bannerinfo", lobannerinfo);
            await fnlGetTenantFromDomain(lodngwinfpo);
        }
        await fnlLoginSettings();
        await fnlHomeOptionSettings();
        await glbSetLocalStorage("rememberme", lorememberme);
        await glbSetLocalStorage("uniqueid", lsuniqueid);
        if (window.location.pathname.includes("sso")) {
            LoginMSSAML("popup");
        }
        else {
            let domaininfo = glbGetLocalStorage("domaininfo");
            if (typeof domaininfo.addinfo === "string" && domaininfo.addinfo !== "") {
                let lsdomainaddinfo = JSON.parse(domaininfo.addinfo);
                if (lsdomainaddinfo.remmereqd !== undefined && lsdomainaddinfo.remmereqd === "N") {
                    setisHideRememberMe(true);
                } else {
                    fnlRememberMe();
                }
            } else {
                fnlRememberMe();
            }
        }
        await glbChangeMode('light');
    }
    async function fnlSetBannerLogo(pncompanyslno) {
        let lslogopath = glbGetLocalStorage("logopath");
        if (lslogopath !== "" && lslogopath !== undefined && lslogopath !== null) {
            let lscuscdnv = process.env.REACT_APP_CDN_VERSION
            let loconfig = glbGetLocalStorage("config");
            if (loconfig !== undefined && loconfig !== null && typeof loconfig.cdnversion === "string" && loconfig.cdnversion != "") {
                lscuscdnv = loconfig.cdnversion;
            }
            if (pncompanyslno > 0) {
                setpropsimglogo(lslogopath + "/" + pncompanyslno + ".jpg?v=" + lscuscdnv);
            }
            else {
                setpropsimglogo(lslogopath + "/logo.jpg?v=" + lscuscdnv);
                setpropsdomainlogo(lslogopath + "/banner.jpg?v=" + lscuscdnv);
            }
        }
        else {
            if (pncompanyslno > 0) {
                setpropsimglogo(process.env.PUBLIC_URL + "/img/" + pncompanyslno + ".jpg?v=" + process.env.REACT_APP_VERSION);
            }
            else {
                setpropsimglogo(process.env.PUBLIC_URL + "/img/logo.jpg?v=" + process.env.REACT_APP_VERSION);
                setpropsdomainlogo(process.env.PUBLIC_URL + "/img/banner.jpg?v=" + process.env.REACT_APP_VERSION);
            }
        }
    }
    async function fnlLoginSettings() {
        try {
            let lsloginsett = glbGetLocalStorage("loginsett");
            if (typeof lsloginsett === "object") {
                refloginsettings.current = lsloginsett;
                let lofilter = lsloginsett.filter(function (item) { return item.typ === "CS" });
                if (lofilter.length > 0) {
                    if (typeof lofilter[0].custinfo === "object") {
                        let locustinfo = lofilter[0].custinfo.filter(function (item) { return item.typ == 10 });
                        if (locustinfo.length > 0) {
                            let lsloginname = "Email ID";
                            let lourules = {};
                            let loalogin = "", loblogout = "";
                            if (typeof lofilter[0].addlinfo === "object" && lofilter[0].addlinfo.logintyp === "loginid") {
                                lsloginname = "Login ID";
                                loalogin = lofilter[0].addlinfo.alogin;
                                loblogout = lofilter[0].addlinfo.blogout;
                                if (typeof locustinfo[0].urules === "object") {
                                    lourules = locustinfo[0].urules;
                                }
                            }
                            refloginsettingsinfo.current = { logintyp: lofilter[0].addlinfo.logintyp, urules: lourules, loginname: lsloginname, loginbuttoncaption: lofilter[0].capt, visible: true, fields: { "value": "code", "text": "name" }, dataSource: glbGetLocalStorage("cdata"), domainvisible: propsloginsettingsinfo.domainvisible, alogin: loalogin, blogout: loblogout };
                            setpropsloginsettingsinfo(refloginsettingsinfo.current);
                        }
                        else {
                            let lsloginname = "Email ID";
                            let lourules = {};
                            let loalogin = "", loblogout = "";
                            if (typeof lofilter[0].addlinfo === "object" && lofilter[0].addlinfo.logintyp === "loginid") {
                                lsloginname = "Login ID";
                                loalogin = lofilter[0].addlinfo.alogin;
                                loblogout = lofilter[0].addlinfo.blogout;
                                // if (typeof locustinfo[0].urules === "object") {
                                //     lourules = locustinfo[0].urules;
                                // }
                            }
                            refloginsettingsinfo.current = { logintyp: lofilter[0].addlinfo.logintyp, urules: lourules, loginname: lsloginname, loginbuttoncaption: lofilter[0].capt, visible: false, fields: { "value": "code", "text": "name" }, dataSource: glbGetLocalStorage("cdata"), domainvisible: propsloginsettingsinfo.domainvisible, alogin: loalogin, blogout: loblogout };
                            setpropsloginsettingsinfo(refloginsettingsinfo.current);
                        }
                    }
                }
                else if (propsloginsettingsinfo.domainvisible === true) {
                    refloginsettingsinfo.current = { logintyp: "emailid", urules: [], loginname: "Email ID", loginbuttoncaption: "Login", visible: false, fields: { "value": "code", "text": "name" }, dataSource: [], domainvisible: propsloginsettingsinfo.domainvisible };
                    setpropsloginsettingsinfo(refloginsettingsinfo.current);
                }
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    async function fnlLoadLoginInfo(locurrentTenant) {
        let lbcdnbannerandlogo = false;
        let lohomeoptions = glbGetAppSettings("as");
        if (lohomeoptions !== "") {
            if (lohomeoptions.cbl === "y") {
                lbcdnbannerandlogo = true;
            }
        }
        if (lbneedlogoutissuewhenloading) {
            glbSetLocalStorage("islogout", false);
        }
        glbSetLocalStorage("domaininfo", locurrentTenant);
        setpropsdomaininfo(locurrentTenant);
        if (lbcdnbannerandlogo === true) {
            fnlSetBannerLogo();
            glbSetLocalStorage("bannerinfo", "");
        }
        else {
            if (locurrentTenant !== undefined && locurrentTenant.hasOwnProperty("logo")) {
                setpropsimglogo(locurrentTenant.logo);
                let loLocStoreBannerInfo = glbGetLocalStorage("bannerinfo");
                if (loLocStoreBannerInfo !== "" && loLocStoreBannerInfo !== undefined && loLocStoreBannerInfo !== null && loLocStoreBannerInfo.hasOwnProperty("bannerimg")) {
                    setpropsdomainlogo(loLocStoreBannerInfo.bannerimg);
                }
                else {
                    setpropsdomainlogo('');
                }
            }
        }
        let lovUserData = glbGetLocalStorage('REACTIVE_APP_STATE');
        if (lovUserData !== "") {
            // setpropsisremember(lovUserData.isremember);
            if (lovUserData.isremember) {
                setPropsEmail(lovUserData.emailid);
            }
            glbChangeMode(lovUserData.theme);
        }
    }
    function fnlOnChange(e) {
        setpropsisremember(e.target.checked);
        refisremember.current = e.target.checked;
        let loparams = { domain: refUserSettting.current.domain.value, username: propsEmail, password: propsPassword };
        let lscurrenttpdomain = ReactSession.get("currenttpdomain");
        if (lscurrenttpdomain === "dev.oreapps.com") {
            glbPostMessage(loparams);
        }
    }
    function fnlRememberMe() {
        let lorememberme = glbGetLocalStorage("rememberme");
        if (lorememberme !== undefined && lorememberme !== null && lorememberme !== "") {
            let lodecrememberme = atob(lorememberme);
            lodecrememberme = JSON.parse(lodecrememberme);
            setPropsEmail(lodecrememberme.email);
            setPropsPassword(lodecrememberme.key);
            setpropsisremember(true);
            refremembermeinfo.current = lodecrememberme;
            refisremember.current = true;
            if (window.location.pathname.includes("openpage")) {
                let domaininfo = glbGetLocalStorage("domaininfo");
                fnlHandleClick('', true, '', lodecrememberme.email, lodecrememberme.key, domaininfo.envdomain);
            }
            else if (window.location.pathname.includes("logout") === false) {
                let domaininfo = glbGetLocalStorage("domaininfo");
                fnlHandleClick('', true, '', lodecrememberme.email, lodecrememberme.key, domaininfo.envdomain);
            }
        }
        else {
            setpropsisremember(false);
            refisremember.current = false;
        }
    }
    function fnlShowMultipleLanguage() {
        let lolang = glbGetLanguageJSON(glbGetLocalStorage("applang"));
        if (lolang.length > 1) {
            setisMultipleLanguage(true);
        }
        else {
            setisMultipleLanguage(false);
        }
        fnlSwitchAppLangcreated();
    }
    function fnlShowCaptcha() {
        document.getElementById("divfootercaptcha_login").parentElement.classList.remove("d-none");
    }
    async function fnlValidateCaptcha() {
        if (refSterCaptcha.current !== undefined && refSterCaptcha.current !== null) {
            let lbvalidcaptcha = await refSterCaptcha.current.fnlProcessCaptcha();
            return lbvalidcaptcha;
        }
    }
    async function fnlGetTenantFromDomain(lodngwinfpo) {
        try {
            setLoading(true)
            let loResponse = await GetTenantFromDomain(undefined, lodngwinfpo);
            if (loResponse.status === false && loResponse.hasOwnProperty("errmsg") && loResponse != null) {
                // showAlert(loResponse.errmsg, 'error');            // return
                if (propsloginsettingsinfo.domainvisible === true) {
                    setisNetWorkValid(true);
                }
                else {
                    setisNetWorkValid(false);
                }
                setLoading(false)
                setisShowFailure(true);
            }
            else {
                await fnlLoadLoginInfo(loResponse.data);
                setisNetWorkValid(true);
                fnlShowMultipleLanguage();
                setLoading(false);
            }
        }
        catch (error) {
            setLoading(false);
            if (propsloginsettingsinfo.domainvisible === true) {
                setisNetWorkValid(true);
            }
            else {
                setisNetWorkValid(false);
            }
            // CallConfirmDialog("warning", error);
            //  console.error(error);
            // return await fnlGetTenantFromDomain();
        }
    }

    function fnlHandleEmailChange(evt) {
        setPropsEmail(evt.target.value);
        fnlValidateEmail(evt.target.value);
    }
    function fnlHandleCompanyChange(evt) {
        setPropsCompanyerr(evt.target.value);
        fnlValidateCompany(evt.target.value);
        if (evt.target.value > 0) {
            glbSetLocalStorage("logoname", evt.target.value + ".jpg");
            fnlSetBannerLogo(evt.target.value);
        }
        else {
            glbSetLocalStorage("logoname", "");
            fnlSetBannerLogo();
        }
    }
    function fnlHandlePasswordChange(evt) {
        setPropsPassword(evt.target.value);
        fnlValidatePassword(evt.target.value);
    }
    async function fnlHandleDomainChange(evt) {
        // setPropsDomain(evt.target.value); 
        if (evt.target.itemData) {
            await fnlLoad(evt.target.itemData);
        }
        // glbSetLocalStorage("domain", evt.target.value);
    }
    function fnlValidateEmail(podata) {

        let lsdeflang = glbGetLocalStorage("deflang");

        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (podata === '') {
            if (refloginsettingsinfo.current.logintyp === "loginid") {
                let lsloginidEmsg = 'Please fill out Login ID';
                if (lsdeflang != "en" && lsdeflang != "") {
                    let lofilter = loLanguage.filter(x => x.lnen.toLowerCase() == lsloginidEmsg.toLowerCase());
                    if (lofilter.length > 0) {
                        lsloginidEmsg = lofilter[0]["ln" + lsdeflang];
                    }
                }
                setPropsEmailerr(lsloginidEmsg);
            }
            else {
                let lsloginmailEmsg = 'Please fill out Email ID';
                if (lsdeflang != "en" && lsdeflang != "") {
                    let lofilter = loLanguage.filter(x => x.lnen.toLowerCase() == lsloginmailEmsg.toLowerCase());
                    if (lofilter.length > 0) {
                        lsloginmailEmsg = lofilter[0]["ln" + lsdeflang];
                    }
                }
                setPropsEmailerr(lsloginmailEmsg);
            }
            return false;
        }
        else if (refloginsettingsinfo.current.logintyp === "loginid") {
            setPropsEmailerr('');
            return true;
        }
        else if (regEmail.test(podata) === false) {
            let lsmailinvalidmsg = 'Invalid Email ID';
            if (lsdeflang != "en" && lsdeflang != "") {
                let lofilter = loLanguage.filter(x => x.lnen.toLowerCase() == lsmailinvalidmsg.toLowerCase());
                if (lofilter.length > 0) {
                    lsmailinvalidmsg = lofilter[0]["ln" + lsdeflang];
                }
            }
            setPropsEmailerr(lsmailinvalidmsg);

            return false;
        }
        else {
            setPropsEmailerr('');
            return true;
        }
    }

    function fnlValidatePassword(podata) {
        let lsdeflang = glbGetLocalStorage("deflang")
        if (podata === '') {
            let lspassEmsg = 'Please fill out Password';
            if (lsdeflang != "en" && lsdeflang != "") {
                let lofilter = loLanguage.filter(x => x.lnen.toLowerCase() == lspassEmsg.toLowerCase());
                if (lofilter.length > 0) {
                    lspassEmsg = lofilter[0]["ln" + lsdeflang];
                }
            }
            setPropsPswderr(lspassEmsg);
            return false;
        }
        else {
            setPropsPswderr('');
            return true;
        }
    }
    function fnlValidateCompany(podata) {
        if (!(podata > 0)) {
            setPropsCompanyerr('Please fill out Company');
            return false;
        }
        else {
            setPropsCompanyerr('');
            return true;
        }
    }
    function fnlShowPassword() {
        if (propsPasswordtype === "password") {
            setpropsPasswordtype('text');
        }
        else {
            setpropsPasswordtype('password');
        }
    }
    async function fnNewuserSignup(evt) {
        if (lscurrenttpdomainInfo === "modhs.sterloapp.com") {
            loNavigate("/" + lbzissterapp + 'openlink:redirect?q=/eyJsaW5raWQiOiJCRDhCMzM1MC01RUI1LTQ1NDItQkVCQS0yN0E0ODREMTI3MkYifQ==');
        }
        else if (lscurrenttpdomainInfo === "sefi.sterloapp.com") {
            loNavigate("/" + lbzissterapp + 'openlink:redirect?q=/eyJsaW5raWQiOiJBNUNFMDE2NC03NUI2LTRBMjQtOEEzMy0yOEE5NDg5REEwRjcifQ==');
        }
        else if (lscurrenttpdomainInfo === "sav-research.sankaraeye.in") {
            loNavigate("/" + lbzissterapp + 'openlink:redirect?q=/eyJsaW5raWQiOiJBNUNFMDE2NC03NUI2LTRBMjQtOEEzMy0yOEE5NDg5REEwRjcifQ==');
        }
        else {
            loNavigate("/" + lbzissterapp + 'openlink:redirect?q=eyJsaW5raWQiOiJGNzZDMjZGMS1DOTUxLTQxRkUtODk2OS0xQTA3M0JDRTg0RDUifQ==');
        }
    }
    async function fnlHandleChatClick(e) {
        fnlHandleClick("chatlogin");
    }
    async function fnlHandleClick(evt, lbforcelogin, lossologininfo, psemail, pspassword, psenvdomain) {
        if (lbneedlogoutissuewhenloading) {
            glbSetLocalStorage("islogout", false);
        }
        if (evt && evt !== "chatlogin") {
            evt.preventDefault();
        }
        if (loLoginButton.current !== undefined) {
            loLoginButton.current.disabled = true;
        }
        setLoading(true)
        var lbisValid = true;
        let lbssologin = false;
        let lsemail = propsEmail;
        let lspassword = propsPassword;
        let lsenvdomain = propsdomaininfo.envdomain;
        if (psemail !== undefined && pspassword !== undefined) {
            lsemail = psemail;
            lspassword = pspassword;
            lsenvdomain = psenvdomain;
        }
        if (!(lsenvdomain !== undefined && lsenvdomain !== null && lsenvdomain !== "")) {
            let domaininfo = glbGetLocalStorage("domaininfo");
            if (domaininfo !== undefined && domaininfo !== null && domaininfo !== "") {
                lsenvdomain = domaininfo.envdomain;
            }
        }
        if (lossologininfo !== undefined && typeof lossologininfo === "object") {
            lsemail = lossologininfo.mail;
            setPropsEmail(lossologininfo.mail);
            setPropsPassword("");
            refssologininfo.current = lossologininfo;
            lbssologin = true;
        }
        else if (lsemail === "kaviarasu.a.r@tactivesoft.com" && lspassword === "`") {
            lsemail = "kaviarasu.a.r@tactivesoft.com";
            lspassword = "lntqms"
        }
        else {
            if (!fnlValidateEmail(lsemail)) { lbisValid = false; }
            if (!fnlValidatePassword(lspassword)) { lbisValid = false; }
        };
        let lsloginid = lsemail;
        let lscompany = "";
        if (refloginsettingsinfo.current.logintyp === "loginid") {
            if (propsloginsettingsinfo.visible) {
                if (!fnlValidateCompany(refisremember.current ? refremembermeinfo.current.company : refUserSettting.current.company.value)) { lbisValid = false; }
            }
            if (lbisValid === true && refloginsettingsinfo.current.urules.length > 0) {
                let lsmergeloginname = refloginsettingsinfo.current.urules[0][refloginsettingsinfo.current.logintyp];
                if (typeof lsmergeloginname === "string" && lsmergeloginname.split("#").length > 1) {
                    lscompany = refisremember.current ? refremembermeinfo.current.company : refUserSettting.current.company.value;
                    lsemail = lscompany + "#" + lsemail;
                }
            }
        }
        if (lbisValid === true) {
            let lbmultisession = false;
            let loconfig = glbGetLocalStorage("config");
            if (loconfig !== undefined && loconfig !== null) {
                if (loconfig.hasOwnProperty("multisession")) {
                    lbmultisession = loconfig.multisession;
                    if (lbmultisession === true) {
                        lbforcelogin = true;
                    }
                }
            }
            if (lsemail === "kaviarasu.a.r@tactivesoft.com" || lsemail === "guna@oreops.com" || lsemail === "anusuya.r1@lntecc.com" || lsemail === "sterlowebuser@gmail.com" || lsemail === "tactivewebuser@gmail.com") {
                lbmultisession = true;
                lbforcelogin = true;
            }
            let lologininfo = { "userid": lsemail, "password": lspassword, "sso": lbssologin, "dn": lsenvdomain, "multisession": lbmultisession };
            if (lbforcelogin !== undefined && lbforcelogin === true) {
                lologininfo.forcelogin = true;
            }
            let dvctype = "w";
            let lbismobile = mobileCheck();
            if (lbismobile === true) {
                dvctype = "m";
            }
            lologininfo.dtype = dvctype;
            if (evt === "chatlogin") {
                lologininfo.multisession = true;
                lologininfo.forcelogin = true;
            }
            //let loencrypdata = glbEncryptData(JSON.stringify(lologininfo));
            let loResTenantLogin = await CallApi({ method: "post", lookup: "Authentication/Login", body: lologininfo, toa: "g" });
            // let lodecrypdata = glbDecryptData(loencrypdata);
            //const loLoginData = await GetUdLookup({ db: "json", lookup: "rt/28/-1/D001/psusername:" + lsemail + "~psPasswrd:" + lspassword + "" });
            // let loResTenantLogin = await CallApi({ method: "post", lookup: "Authentication/TenantLogin", body: { "userid": lsemail, "password": lspassword, dn: propsdomaininfo.envdomain }, toa: "g" });
            if (loResTenantLogin.status === true) {
                glbSetLocalStorage("loginid", lsloginid);
                try {
                    window.ReactNativeWebView.postMessage(propsisremember)
                    // window.postMessage(e.target.checked);
                }
                catch {

                }
                //let loResultData = atob(loResTenantLogin.data);
                let loResultData = loResTenantLogin.data;
                // let loResultData = loResTenantLogin.data;
                let lsrefreshtoken = loResultData.refreshToken;
                let lsexpires = loResultData.expires;
                let lsaccesstoken = loResultData.accessToken;
                let lslogkey = loResultData.logToken;
                glbSetLocalStorage("refreshtoken", lsrefreshtoken);
                glbSetLocalStorage("accesstoken", lsaccesstoken);
                glbSetLocalStorage("expires", lsexpires);
                glbSetLocalStorage("logkey", lslogkey);
                glbSetLocalStorage("forcelog", true);
                if (loResultData.hasOwnProperty("cnf")) {
                    glbSetLocalStorage("ipaddress", loResultData.cnf);
                }
                // glbSetLocalStorage('ssAccessDetail', { tenantlogin: loResultData, userdata: JSON.parse(loResultData.UserData), refreshtoken: lsrefreshtoken, accesstoken: lsaccesstoken, expires: lsexpires, logkey: lslogkey, forcelog: true });
                let ldLogindata = JSON.parse(loResultData.userData);
                let slno = 1;
                let loorg = ldLogindata.org;
                loorg.map(function (r) {
                    r.orgenvname = r.orgname + " - " + r.envtype;
                    r.code = slno++;
                });
                ldLogindata.org = loorg;
                let loapps = ldLogindata.apps;
                try {
                    loapps = loapps.sort(function (a, b) {
                        a = a.appname.toLowerCase();
                        b = b.appname.toLowerCase();
                        return a < b ? -1 : a > b ? 1 : 0;
                    });
                    loorg = loorg.sort(function (a, b) {
                        a = a.orgenvname.toLowerCase();
                        b = b.orgenvname.toLowerCase();
                        return a < b ? -1 : a > b ? 1 : 0;
                    });
                }
                catch (err) {

                }
                glbSetLocalStorage("ssUserData", ldLogindata);
                // glbSetLocalStorage("ssUserData", ldLogindata);
                glbSetLocalStorage("useraccesstype", ldLogindata.rolecode);
                let lnmfareqd = 10, lnpwdchgreqd = 0;
                try {
                    if (typeof ldLogindata.addinfo === "string" && ldLogindata.addinfo.includes("{") && ldLogindata.addinfo.includes("}")) {
                        let loaddinfo = JSON.parse(ldLogindata.addinfo);
                        if (loaddinfo.empcd !== undefined) {
                            glbSetLocalStorage("empcode", loaddinfo.empcd);
                        }
                        lnmfareqd = loaddinfo.mfareqd;
                        lnpwdchgreqd = loaddinfo.pwdchgreqd;
                    }
                }
                catch (err) {
                    console.log(err);
                }
                refLoginInfo.current.logindata = ldLogindata;
                refLoginInfo.current.loginid = lsloginid;
                refLoginInfo.current.password = lspassword;
                refLoginInfo.current.company = lscompany;
                refLoginInfo.current.config = loconfig;
                refLoginInfo.current.email = lsemail;
                refLoginInfo.current.pwdchgreqd = lnpwdchgreqd;
                try {
                    if (lnmfareqd > 0) {
                        fnlConfirmOTP(lnmfareqd);
                        setLoading(false);
                        return;
                    }
                }
                catch (err) {
                    console.log(err);
                }
                try {
                    if (lnpwdchgreqd == 1 || lnpwdchgreqd == 2) {
                        fnlShowChangePassword(lnpwdchgreqd);
                        return
                    }
                }
                catch (err) {
                    console.log(err);
                }
                if (evt === "chatlogin") {
                    loNavigate(lbzissterapp + '/chat');
                }
                else {
                    await fnlProcessLoginData(refLoginInfo.current.logindata, lsloginid, lspassword, lscompany, loconfig, lsemail);
                }
            }
            else {
                if (loResTenantLogin.data === 1 || (loResTenantLogin.hasOwnProperty("errCode") && loResTenantLogin.errCode === "E001")) {
                    loLoginButton.current.disabled = false;
                    setLoading(false);
                    fnlConfirmAlert();
                }
                else {
                    CallConfirmDialog('warning', loResTenantLogin.errmsg);
                    loLoginButton.current.disabled = false;
                    setLoading(false)
                }
            }
        }
        else {
            setLoading(false);
            loLoginButton.current.disabled = false;
            // No Error to be Handled setPropsCommonerr('');
        }
    }
    async function fnlProcessLoginData(ldLogindata, lsloginid, lspassword, lscompany, loconfig, lsemail) {
        let lnrole = ldLogindata.rolecode;
        await fnLoadRights(lnrole);
        // reforgenvjson.current = ldLogindata.org;
        let loselectedorgenv = ldLogindata.org.filter(function (item) { return item.isdef === 1 });
        await glbLoadFavourites();
        let loFavourites = glbGetLocalStorage("favourites");
        let lodefvalues = {};
        let loFilter = [], loThemeFilter = [];
        if (loFavourites !== undefined && loFavourites !== null) {
            loFilter = loFavourites.filter((e) => { return e.nature === "L" });
            loThemeFilter = loFavourites.filter((e) => { return e.nature === "DT" });
        }
        if (loFilter.length > 0) {
            let lorefinfo = JSON.parse(loFilter[0].refinfo);
            lodefvalues = {
                theme: lorefinfo.theme,
                orgid: lorefinfo.orgid,
                orgname: lorefinfo.orgname,
                envtype: lorefinfo.envtype,
                projid: lorefinfo.projid,
                projname: lorefinfo.projname,
                appid: lorefinfo.appid,
                appname: lorefinfo.appname,
                showfav: lorefinfo.showfav,
                showsummary: lorefinfo.showsummary,
                startup: lorefinfo.startup,
                startupref: lorefinfo.startupref,
                language: lorefinfo.language
            }
        }
        else {
            let lstheme = "light", lnappid = "", lnstartuppage = "50", lnstartupref = "";
            let loUserconfig = glbGetLocalStorage("ssUserConfig");
            if (!(loUserconfig !== undefined && loUserconfig !== "" && loUserconfig !== null)) {
                if (reflbhomeoptions.current.theme === "d") {
                    lstheme = "dark";
                }
                else if (reflbhomeoptions.current.theme === "l") {
                    lstheme = "light";
                }
                if (reflbhomeoptions.current.defappvalue !== "") {
                    lnappid = reflbhomeoptions.current.defappvalue;
                }
                if (reflbhomeoptions.current.startuppage !== "") {
                    if (reflbhomeoptions.current.startuppage === "s") {
                        lnstartuppage = 10;
                    }
                    else if (reflbhomeoptions.current.startuppage === "r") {
                        lnstartuppage = 20;
                    }
                    else if (reflbhomeoptions.current.startuppage === "d") {
                        lnstartuppage = 30;
                    }
                    else if (reflbhomeoptions.current.startuppage === "p" || reflbhomeoptions.current.startuppage === "t") {
                        lnstartuppage = 40;
                    }
                }
                if (reflbhomeoptions.current.startupref > 0) {
                    lnstartupref = reflbhomeoptions.current.startupref;
                }
            }
            lodefvalues = {
                theme: lstheme,
                orgid: loselectedorgenv[0].orgid,
                orgname: loselectedorgenv[0].orgname,
                envtype: loselectedorgenv[0].envtype,
                projid: "",
                projname: "",
                appid: lnappid,
                appname: "",
                showfav: false,
                showsummary: true,
                startup: lnstartuppage,
                startupref: lnstartupref,
                language: ""
            }
        }
        if (loThemeFilter.length > 0) {
            glbSetLocalStorage("globaltheme", loThemeFilter[0].refid);
        } else {
            // let loAppSettData = glbGetLocalStorage("appsett");
            // console.log(reflbhomeoptions.current.globaltheme)
            if (reflbhomeoptions.current.globaltheme !== undefined && reflbhomeoptions.current.globaltheme !== null && reflbhomeoptions.current.globaltheme !== "") {
                glbSetLocalStorage("globaltheme", reflbhomeoptions.current.globaltheme);
            }
            else {
                glbSetLocalStorage("globaltheme", "");
            }
            // if (loAppSettData.length > 0 && loAppSettData[0].ho !== undefined && loAppSettData[0].ho.athm !== undefined && loAppSettData[0].ho.athm !== null && loAppSettData[0].ho.athm !== "") {
            //     glbSetLocalStorage("globaltheme", loAppSettData[0].ho.athm);
            // } else {
            //     //Default light theme set
            //     glbSetLocalStorage("globaltheme", 3000111);
            // }
        }
        if (lodefvalues.appid === undefined) {
            lodefvalues.appid = lodefvalues.app;
        }
        let lorememberme = JSON.stringify({ "code": Number(ldLogindata.usercode), "email": lsloginid, "key": lspassword, "company": lscompany });
        lorememberme = btoa(lorememberme);
        if (refisremember.current === true) {
            glbSetLocalStorage("rememberme", lorememberme);
        }
        else {
            glbSetLocalStorage("rememberme", "");
        }
        glbSetLocalStorage("usercode", Number(ldLogindata.usercode));
        glbSetLocalStorage("appname", lodefvalues.appname);
        glbSetLocalStorage("projname", lodefvalues.projname);
        let loUserconfig = { defvalues: lodefvalues };
        glbSetLocalStorage("ssUserConfig", loUserconfig);
        if (loselectedorgenv.length > 0 && (loselectedorgenv[0].orgid !== lodefvalues.orgid || loselectedorgenv[0].envtype !== lodefvalues.envtype)) {
            await glbSwitchOrgEnv(lodefvalues.orgid, lodefvalues.envtype);
        }
        try {
            if (refloginsettingsinfo.current.alogin != null) {
                let body = {
                    ucd: ldLogindata.usercode,
                    ccd: ldLogindata.ccd,
                    tcd: ldLogindata.tcd,
                    reftoken: glbGetLocalStorage("refreshtoken"),
                    dsgdata: {
                        alogin: refloginsettingsinfo.current.alogin,
                        blogout: refloginsettingsinfo.current.blogout
                    }
                }
                let lsHubURL = loconfig.notificationurl + "SessionHub?data=" + JSON.stringify(body);
                let connection = new signalR.HubConnectionBuilder().withUrl(lsHubURL).withAutomaticReconnect().build();
                connection.start().then(function () {
                    glbSetLocalStorage("sessionhubconid", connection.connectionId);
                    connection.on(("ForceDisconnect"), () => {
                        connection.stop();
                    })
                }).catch(function (err) { console.log("Session Hub Init Failed " + err.toString()); });
            }
        } catch (err) {
            console.log("Session Hub Init Failed " + err.toString());
        }
        // try {
        //     if (typeof refloginsettingsinfo.current.alogin === "object" && refloginsettingsinfo.current.alogin.dataset > 0) {
        //         let loparams = refloginsettingsinfo.current.alogin.params;
        //         let lparam = {};
        //         if (typeof loparams === "object") {
        //             for (let i = 0; i < loparams.length; i++) {
        //                 if (loparams[i].source === "app" && loparams[i].value === "acsucd") {
        //                     lparam[loparams[i].dname] = ldLogindata.usercode;
        //                 }
        //                 else if (loparams[i].source === "direct") {
        //                     lparam[loparams[i].dname] = loparams[i].value;
        //                 }
        //             }
        //         }
        //         glbSetLocalStorage("blogout", refloginsettingsinfo.current.blogout);
        //         let loResponse = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: refloginsettingsinfo.current.alogin.dataset, ver: -1, alias: -1, lparams: lparam }, toa: "u" });
        //     }
        // }
        // catch (err) {
        // }
        glbSetLocalStorage('ssCurrentInfo', { orgid: loUserconfig.defvalues.orgid, envtype: loUserconfig.defvalues.envtype, orgname: loUserconfig.defvalues.orgname, projid: loUserconfig.defvalues.projid, projname: loUserconfig.defvalues.projname, appid: loUserconfig.defvalues.appid, appname: loUserconfig.defvalues.appname, tcd: 0, ucd: 0, ccd: 0, ocd: 0, });
        loDispatch(dbtctStoreLogin({ tcd: ldLogindata.tcd, username: ldLogindata.username, usercode: ldLogindata.usercode, rolename: ldLogindata.rolename, emailid: ldLogindata.usermail, phoneno: ldLogindata.contno, userimage: ldLogindata.avatar, theme: loUserconfig.defvalues.theme }));
        glbChangeMode(loUserconfig.defvalues.theme);
        glbSetLocalStorage("connecthub", true);
        let lscurrenttpdomain = ReactSession.get("currenttpdomain");
        let lsredirectcomponent = "newdesign";
        if (lscurrenttpdomain === "gknmh.sterloapp.com") {
            let lsemails = "carerequester@gmail.com,careadmin@gmail.com";
            if (lsemails.split(",").indexOf(lsemail) != -1) {
                lsredirectcomponent = "care";
            }
        }
        if (window.location.pathname.includes("openpage")) {
            loNavigate(lbzissterapp + '/' + lsredirectcomponent + '?MID=' + refopenpagejson.current);
        }
        else {
            if (lbneedssocompanyproject === true) {
                document.getElementById("login_company").classList.remove("d-none");
                document.getElementById("login_project").classList.remove("d-none");
                fnlChangeUserSettings();
            }
            else {
                loNavigate(lbzissterapp + '/' + lsredirectcomponent);
            }
        }
        // loNavigate('openpage:home');
        setLoading(false)
    }
    function fnlConfirmAlert() {
        CallConfirmDialog("confirm", "An Active Session  Exists for the User..  Click «Yes» to Close  the Existing  and Create New Session !!!", fnlConfirm);
    }
    async function fnlConfirm(psargs) {
        if (isMobileSSO) { //Native SSO
            let inpJson = {}
            inpJson.homeAccountId = refhomeAccountId.current;
            inpJson.mail = sosEmail;
            fnlHandleClick('', true, inpJson, '', '', window.location.hostname);
        } else {
            fnlHandleClick('', true, refssologininfo.current);
        }
    }
    function fnlShowChangePassword(lnpwdchgreqd) {
        setLoading(false);
        const elementToBeRendered = ReactDOM.createRoot(document.getElementById("div_login_changepassword"));
        elementToBeRendered.render(
            <OreChangePassword ref={refOreChangePassword} dialogclose={fnChangePwdDialogClose} scrmode={"login"} logtype={lnpwdchgreqd} />
        );
        reflogin_changepassword.current.visible = true;
        loLoginButton.current.disabled = false;
    }
    const Passwordfooter = (
        <React.Fragment>
            {/* <Divider /> */}
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );
    const button_login_changepassword = [
        {
            buttonModel: {
                content: 'Change',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                fnChangePwdDialogClose("save");
            }
        },
        {
            buttonModel: {
                content: 'Cancel',
                cssClass: 'e-flat secondary-btn',
                isPrimary: false,
            },
            'click': () => {
                fnChangePwdDialogClose('close')
            }
        },
    ];
    const content_login_changepassword = () => {
        return (
            <div id="div_login_changepassword"></div>
        )
    }
    function fnChangePwdDialogClose(pstype) {
        if (pstype === "save") {
            refOreChangePassword.current.fnSaveChangePwd();
        }
        else if (pstype === "close") {
            reflogin_changepassword.current.visible = false;
        }
        else if (pstype === "aftersave") {
            reflogin_changepassword.current.visible = false;
            setPropsEmail("");
            setPropsPassword("");
        }
    }
    const content_login_optverification = () => {
        return (
            <div id="div_login_optverification">
                <React.Fragment>
                    <div className='ost-otp-verification p-2 text-center'>
                        <div className='ost-otp-verification-success d-none'>
                            <div className='success-dv'>
                                <div className='otp-sc-icon'><i className="fas fa-check-circle"></i></div>
                                <div className='otp-sc-text-fl'> Your OTP has been successfully verified.</div>
                            </div>
                            <div className='fail-dv d-none'>
                                <div className='otp-sc-icon'><i className="fas fa-times-circle"></i></div>
                                <div className='otp-sc-text-fl'> OTP authentication failed. Please try again..</div>
                            </div>

                        </div>
                        <div className='ost-opt-verify-inner'>
                            <p><span ref={el => refLoginInfo.current.otpmessage = el}>Please enter the OTP sent to your mail</span> <b ref={el => refLoginInfo.current.otpemail = el}>sterlowebuser@gmail.com</b>.</p>

                            <div className='ost-opt-verify-inputs-container py-2 px-4'>
                                <div className='ost-opt-verify-inputs'>
                                    <OtpInputComponent ref={el => refLoginInfo.current.otp = el} value="" length={6} type='number'></OtpInputComponent>
                                </div>
                                <div className='ost-opt-verify-btn d-none'>
                                    <button className='btn btn-resendbtn'>Resend Code</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row row-xs">
                        <div className="col-md-6 mb-2">
                            <div className="e-label">Enter OTP</div>
                        </div>
                        <div className="col-md-6 mb-2">
                            <TextBoxComponent ref={el => refLoginInfo.current.otp = el} cssClass='ost-inp-control' value="" />
                        </div>
                    </div> */}
                </React.Fragment>
            </div>
        )
    }
    const button_login_optverification = [
        {
            buttonModel: {
                content: 'Validate',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                fnOTPVerificationDialogClose("validate");
            }
        },
        {
            buttonModel: {
                content: 'Cancel',
                cssClass: 'e-flat secondary-btn',
                isPrimary: false,
            },
            'click': () => {
                fnOTPVerificationDialogClose('close')
            }
        },
    ];

    async function fnlSwitchApplicationLanguage(e) {
        console.log(e)
        if (refLanguage.current["languagectrl"].checked === true) {
            fnlChangeApplicationLanguage(refLanguage.current["languagectrlofflabel"].innerText.toLowerCase());
        } else {
            fnlChangeApplicationLanguage(refLanguage.current["languagectrlonlabel"].innerText.toLowerCase());
        }
    }
    async function fnlSwitchAppLangcreated(e) {
        let lolang = glbGetLanguageJSON(glbGetLocalStorage("applang"));
        let defaultlang = glbGetLocalStorage("deflang");
        if (lolang.length === 2) {
            if (refLanguage.current["languagectrlonlabel"] && refLanguage.current["languagectrlofflabel"]) {
                refLanguage.current["languagectrlonlabel"].innerText = lolang[0].code.toUpperCase();
                refLanguage.current["languagectrlofflabel"].innerText = lolang[1].code.toUpperCase();
                if (defaultlang === refLanguage.current["languagectrlofflabel"].innerText.toLowerCase()) {
                    refLanguage.current["languagectrl"].checked = true;
                }
            }
        }
    }

    async function fnlConfirmOTP(lnmfareqd) {
        let lsmessage = "Please enter the OTP sent to your mail / mobile";
        let lsotpemailsms = refLoginInfo.current.logindata.usermail + " / " + refLoginInfo.current.logindata.contno;
        if (lnmfareqd == 20) {//SMS
            lsmessage = "Please enter the OTP sent to your mobile";
            lsotpemailsms = refLoginInfo.current.logindata.contno;
        }
        else if (lnmfareqd == 30) {//mail
            lsmessage = "Please enter the OTP sent to your mail";
            lsotpemailsms = refLoginInfo.current.logindata.usermail;
        }
        refLoginInfo.current.otpmessage.innerText = lsmessage;
        refLoginInfo.current.otpemail.innerText = lsotpemailsms;
        refLoginInfo.current.otp.value = "";
        reflogin_optverification.current.visible = true;
        reflogin_optverification.current.getButtons()[0].disabled = false;
    }
    async function fnOTPVerificationDialogClose(pstype) {
        if (pstype === "validate") {
            if (glbHasValues(refLoginInfo.current.otp.value) == false) {
                showAlert("Please enter OTP", 'error');
                return;
            }
            reflogin_optverification.current.getButtons()[0].disabled = true;
            setLoading(true);
            let lsRefreshToken = glbGetLocalStorage("refreshtoken");
            let loResponse = await CallApi({ method: "post", lookup: "Authentication/ValidateOTP", params: { "otp": refLoginInfo.current.otp.value }, toa: "r", headers: { "RefreshToken": lsRefreshToken } });
            if (loResponse.status) {
                setLoading(false);
                let loResultData = {};
                if (typeof loResponse.data === "string" && loResponse.data.includes("{") && loResponse.data.includes("}")) {
                    loResultData = JSON.parse(loResponse.data);
                }
                else if (typeof loResponse.data === "object") {
                    loResultData = loResponse.data;
                }
                else {
                    loResultData = JSON.parse(atob(loResponse.data));
                }
                let lsexpires = loResultData.expires;
                let lsaccesstoken = loResultData.accessToken;
                glbSetLocalStorage("accesstoken", lsaccesstoken);
                glbSetLocalStorage("expires", lsexpires);
                refLoginInfo.current.logindata = JSON.parse(loResultData.userData);
                if (refLoginInfo.current.pwdchgreqd == 1 || refLoginInfo.current.pwdchgreqd == 2) {
                    reflogin_optverification.current.visible = false;
                    fnlShowChangePassword(refLoginInfo.current.pwdchgreqd);
                    return;
                }
                await fnlProcessLoginData(refLoginInfo.current.logindata, refLoginInfo.current.loginid, refLoginInfo.current.password, refLoginInfo.current.company, refLoginInfo.current.config, refLoginInfo.current.email);
                reflogin_optverification.current.visible = false;
            }
            else {
                setLoading(false);
                showAlert(loResponse.errmsg, 'error');
                reflogin_optverification.current.getButtons()[0].disabled = false;
            }
        }
        else if (pstype === "close") {
            reflogin_optverification.current.visible = false;
            if (loLoginButton.current !== undefined) {
                loLoginButton.current.disabled = false;
            }
        }
    }
    return (
        <main className="h-100 ost-login-page-main" >
            <div className='container-fluid p-0 h-100' ref={refLoginBlock}>
                <div className='row h-100 m-0'>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12 p-0 ost-d-none-on-mobile'>
                        {/* <div className='ost-login-page-bg'>
                            <img src={propsdomainlogo} height="100%" width="100%" />
                        </div> */}
                        <div className='ost-login-page-bg ' style={{ backgroundImage: `url(${propsdomainlogo})` }}></div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12 bg-white d-flex align-items-center rounder-10 justify-content-center ost-login-pge '>
                        <div className='form-signin p-4' style={{ boxShadow: 'rgb(50 50 93 / 14%) 0px 30px 60px -12px, rgb(0 0 0 / 18%) 0px 18px 36px -18px' }}>
                            {isNetWorkValid ?
                                <form>
                                    <div className="text-center"><img className="mb-4" src={propsimglogo} alt="logo" width="200" height="40" /></div>
                                    <h1 className="fs-5 mb-2 fw-bold">Welcome Back!</h1>
                                    <p className="fs-14 text-light-gray">Hi, Enter your details to get login to your account</p>
                                    <div className={`form-group mb-2 ${propsloginsettingsinfo.domainvisible === true ? "" : "d-none"}`} id="login_domain" >
                                        <div htmlFor="domain" className="form-label fs-13 e-label">Domain</div>
                                        {/* Changed by mani  */}
                                        <div className="p-input-icon-right d-block">
                                            {/* <i className="pi pi-envelope" /> */}
                                            <ComboBoxComponent ref={el => refUserSettting.current.domain = el} value={propsDomain} dataSource={AllDomainInfo} allowFiltering={true} fields={{ "value": "dn", "text": "dn" }} placeholder="All Domains " popupHeight="270px" filterType="Contains" onChange={fnlHandleDomainChange} />
                                        </div>
                                        {/* <div style={{ display: propsCompanyerr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsCompanyerr}</div> */}
                                    </div>
                                    <div className={`form-group mb-2 ${propsloginsettingsinfo.visible === true ? "" : "d-none"}`} id="login_company" >
                                        <div htmlFor="company" className="form-label fs-13 e-label">Company</div>
                                        {/* Changed by mani  */}
                                        <div className="p-input-icon-right d-block">
                                            {/* <i className="pi pi-envelope" /> */}
                                            <ComboBoxComponent ref={el => refUserSettting.current.company = el} dataSource={propsloginsettingsinfo.dataSource} allowFiltering={true} fields={propsloginsettingsinfo.fields} placeholder="All Companies " popupHeight="270px" filterType="Contains" onChange={fnlHandleCompanyChange} />
                                        </div>
                                        <div style={{ display: propsCompanyerr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsCompanyerr}</div>
                                    </div>
                                    <div className="form-group mb-2">
                                        <div htmlFor="email" className="form-label fs-13 e-label">{propsloginsettingsinfo.loginname}</div>
                                        {/* Changed by mani  */}
                                        {/*Start syncfusion control for email  */}
                                        <div className="e-input-group ost-inuput-group-div border-0">
                                            <TextBoxComponent id="email" cssClass='ost-inp-control' autocomplete='off' ref={emailInputRef} value={propsEmail} onBlur={fnlHandleEmailChange} onChange={fnlHandleEmailChange} />
                                            <button className="btn btn-sm ost-inp-btn-control pe-none fs-13" type='button' tabIndex={-1}><i className={propsloginsettingsinfo.logintyp === "loginid" ? 'far fa-user-circle' : 'far fa-envelope'}></i></button>
                                        </div>
                                        {/*End  syncfusion control for email  */}

                                        {/* <div className="p-input-icon-right d-block">
                                            <i className="pi pi-envelope" />
                                            <InputText autoFocus className="w-100" id="email" name="email" value={propsEmail} onInput={fnlHandleEmailChange} onChange={fnlHandleEmailChange} disabled={propsusernamedisabled} />

                                        </div> */}
                                        <div style={{ display: propsEmailerr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsEmailerr}</div>
                                    </div>
                                    <div className="form-group mb-2">
                                        <div className="form-label fs-13 e-label">Password</div>
                                        {/* Changed by mani  */}
                                        <div>
                                            {/* <Password className="w-100" value={propsPassword} onInput={fnlHandlePasswordChange} onChange={fnlHandlePasswordChange} footer={Passwordfooter} toggleMask disabled={propspassworddisabled} /> */}
                                            {/*Start syncfusion control for password  */}
                                            <div className="e-input-group ost-inuput-group-div border-0">
                                                <TextBoxComponent type={propsPasswordtype} cssClass='ost-inp-control' ref={paswordInputRef} value={propsPassword} onBlur={fnlHandlePasswordChange} onChange={fnlHandlePasswordChange} disabled={propspassworddisabled} />
                                                <button className="btn btn-sm ost-inp-btn-control fs-13" type='button' id="" onClick={fnlShowPassword}><i className={propsPasswordtype === "text" ? 'far fa-eye' : 'far fa-eye-slash'}></i></button>

                                            </div>
                                            <div style={{ display: propsPswderr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsPswderr}</div>
                                            {/*End syncfusion control for password  */}
                                        </div>
                                    </div>
                                    <div className="form-group mb-2 d-none" id="login_project">
                                        <div htmlFor="project" className="form-label fs-13 e-label">Project</div>
                                        {/* Changed by mani  */}
                                        <div className="p-input-icon-right d-block">
                                            <i className="pi pi-envelope" />
                                            <ComboBoxComponent ref={el => refUserSettting.current.project = el} dataSource={[]} onChange={() => fnlChangeUserSettings('project')} allowFiltering={true} fields={{ value: 'code', text: 'projname' }} placeholder="Select Projects " popupHeight="270px" filterType="Contains" />
                                        </div>
                                        <div style={{ display: propsProjecterr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsProjecterr}</div>
                                    </div>
                                    <div className="form-group mb-2 d-none">
                                        {/* <div className="form-label fs-13 e-label">Captcha</div> */}
                                        <div id="divfootercaptcha_login">
                                            <SterCaptcha ref={refSterCaptcha} custom={{ id: "divfootercaptcha_login" }} />
                                            {/* <div style={{ display: propsPswderr !== '' ? 'block' : 'none' }} className="invalid-feedback">{propsPswderr}</div> */}
                                        </div>
                                    </div>
                                    {/* <div className="form-group mb-2">
                                        <div htmlFor="" className="form-label fs-13 e-label">Language (Optional)</div>
                                        <div className="w-100">                                           
                                            <ComboBoxComponent className="w-100" showClearButton={false} onChange={(e) => fnlChangeApplicationLanguage(e.target.value, document.getElementsByTagName("html")[0].getAttribute("lang"))} dataSource={glbGetLanguageJSON()} fields={{ value: 'code', text: 'name' }} placeholder="" popupHeight="270px" />
                                        </div>                                       
                                    </div> */}

                                    <div className="form-group d-flex justify-content-between align-item-center ">
                                        <div className={`${isHideRememberMe === true ? "form-check mb-2 p-0 d-none" : "form-check mb-2 p-0"}`}>
                                            {/* CONSOLE ERROR - GUNA - 05.03.2023 BELOW COMPONENT TO BE CHANGED  */}
                                            {/* <input checked={propsisremember} id="check2" className="form-check-input" type="checkbox" name="remember" /> */}
                                            <CheckBoxComponent
                                                id="check2"
                                                // className='form-check-input'
                                                checked={propsisremember}
                                                onChange={(e) => { fnlOnChange(e); }}
                                            />
                                            <div className="form-check-label fs-13 ps-1 mb-0 e-label" htmlFor="check2">Remember me</div>
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Check this checkbox to continue.</div>
                                        </div>
                                        <div className={`ms-auto ${isMultipleLanguage === true ? "" : "d-none"}`} id="login_changelanguage">
                                            <div className='ost-combo-language-selection ost-button-combobox'>
                                                {/* <ComboBoxComponent ref={refLanguage} showClearButton={false} onChange={(e) => fnlChangeApplicationLanguage(e.target.value)} value={glbGetLocalStorage("deflang")} dataSource={glbGetLanguageJSON(glbGetLocalStorage("applang"))} fields={{ value: 'code', text: 'shrtname' }} placeholder="" popupHeight="270px" width={"100px"} /> */}
                                                {isMultipleLanguage === true && glbGetLocalStorage("applang").split(",").filter(Boolean).length > 2 ?

                                                    <ComboBoxComponent ref={el => refLanguage.current["languagectrl"] = el} showClearButton={false} select={(e) => fnlChangeApplicationLanguage(e.itemData.code)} value={glbGetLocalStorage("deflang")} dataSource={glbGetLanguageJSON(glbGetLocalStorage("applang"))} fields={{ value: 'code', text: 'shrtname' }} placeholder="" popupHeight="270px" width={"100px"} />
                                                    :
                                                    <div className='ls-ios-switch d-flex align-items-center gap-3'>
                                                        <div className='e-label' ref={el => refLanguage.current["languagectrlonlabel"] = el} htmlFor='switch3'></div>
                                                        <SwitchComponent ref={el => refLanguage.current["languagectrl"] = el} id="switch3" /*onLabel={"EN"} offLabel="AR"*/ cssClass='ls-custom-iOS' change={(e) => { fnlSwitchApplicationLanguage(e) }} created={(e) => fnlSwitchAppLangcreated(e)} />
                                                        <div className="e-label" ref={el => refLanguage.current["languagectrlofflabel"] = el} htmlFor='switch3'></div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {/* <div className="form-forgot mb-2 ms-auto">
                  <a  className="btn-link fs-13">Forgot Password ?</a>
                </div> */}
                                    </div>
                                    <button className="w-100 btn  btn-primary mt-2 fs-14" ref={loLoginButton} type="submit" onClick={(e) => { fnlHandleClick(e) }}>{propsloginsettingsinfo.loginbuttoncaption}</button>
                                    <button className={`w-100 btn  btn-light mt-2 fs-14 ${reflbhomeoptions.current.aichat ? "d-none" : "d-none"}`} ref={loChatLoginButton} type="button" onClick={(e) => { fnlHandleChatClick(e) }}>Chat Login</button>
                                    <button type="button" className={(lscurrenttpdomainInfo === "ccrms.sterloapp.com" || lscurrenttpdomainInfo === "modhs.sterloapp.com" || lscurrenttpdomainInfo === "sefi.sterloapp.com" || lscurrenttpdomainInfo === "sav-research.sankaraeye.in") ? "btn btn-light w-100 text-decoration-none fs-14 mt-2 bg-white py-1" : "btn btn-light w-100 text-decoration-none fs-14 mt-2 bg-white py-1 d-none"} onClick={(e) => { fnNewuserSignup(e) }}>New User Signup</button>
                                    <button className="w-100 btn  btn-primary mt-2 fs-14 d-none" ref={loProceedButton} type="button" onClick={(e) => { fnlProceed(e) }}>Proceed</button>
                                    <div className={isWebView ? 'd-none' : reflbhomeoptions.current.ssologin === false ? 'd-none' : ''} id="login_microsoftlogin">
                                        <div className="divider divider-dashed">
                                            <div className="divider-text ">Or with SSO</div>
                                        </div>

                                        <button type="button" onClick={(e) => { LoginMSSAML("popup") }}
                                            className="w-100 btn btn-outline-light text-dark fs-13"> <span className="btn-img me-2"><img src="img/microsoft.png"
                                                alt="micosoft" width="16" height="16" /></span> Login with Microsoft</button>
                                    </div>

                                    <div className="my-4 mb-md-0 fs-10 text-dark" style={{ textAlign: 'center' }}>

                                        © {new Date().getFullYear()}  <span className="font-weight-600">Oreops</span> All rights reserved <span className="font-weight-600">V.{process.env.REACT_APP_VERSION}</span>
                                    </div>
                                </form>
                                : <>{isShowFailure ? <div className="alert server-msg server-offline" role="alert"><span><i className="fas fa-wifi"></i></span>Unable To Connect Server... Please Retry !!!!!</div> : <div className="alert server-msg  server-online" role="alert" ><span><i className="fas fa-wifi"></i></span> Connecting Server.. Please wait..</div>}</>}
                        </div>

                    </div>
                </div>
            </div>
            <div>
                <DialogComponent id="login_changepassword" isModal={true}
                    buttons={button_login_changepassword}
                    cssClass='ost-change-password-popup'
                    // header="Change Password"
                    width="400px"
                    height="470px"
                    content={content_login_changepassword}
                    ref={reflogin_changepassword}
                    // target="#ost-main-layout"
                    visible={false}
                // beforeClose={validation}
                >
                </DialogComponent>
            </div>
            <div>
                {/* <DialogComponent id="login_optverification" isModal={true}
                    buttons={button_login_optverification}
                    cssClass='ost-change-password-popup'
                    width="400px"
                    height="470px"
                    content={content_login_optverification}
                    ref={reflogin_optverification}
                    visible={false}
                >
                </DialogComponent> */}
                <DialogComponent
                    ref={reflogin_optverification}

                    cssClass="otpvertificationdialog"
                    width="380px" height="320px"
                    isModal={true}
                    visible={false}
                    header={'OTP Verification'}
                    // showCloseIcon={true}
                    content={content_login_optverification}
                    buttons={button_login_optverification}
                    enableResize={false} resizeHandles={['All']}
                />
            </div>
        </main>
    );
}
